import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Paper,
  Typography,
  Grid,
  Chip,
  Stack,
} from '@mui/material';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import TransformIcon from '@mui/icons-material/Transform';

const processes = [
  {
    name: 'PS 1/26 Process',
    description: 'Internes Chunken - Produktionsablauf PS 1/26. Übergang von Test-Phase zu Produktiv.',
    icon: AccountTreeIcon,
    path: '/processes/ps-1-26',
    participants: ['Kai', 'Michael', 'Moritz', 'Joris', 'Pia', 'Alex', 'Jürgen'],
    color: '#35677f',
  },
  {
    name: 'DOCX Conversion Pipeline',
    description: 'DOCX → PDF Konvertierungspipeline. Prozessablauf für die Entwicklung.',
    icon: TransformIcon,
    path: '/processes/docx-conversion',
    participants: ['transcript', 'le-tex'],
    color: '#059669',
  },
];

function ProcessCard({ process }) {
  const navigate = useNavigate();
  const IconComponent = process.icon;

  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: 4,
        },
      }}
      onClick={() => navigate(process.path)}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            backgroundColor: `${process.color}15`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <IconComponent sx={{ fontSize: 28, color: process.color }} />
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            {process.name}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {process.description}
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            {process.participants.map((participant) => (
              <Chip
                key={participant}
                label={participant}
                size="small"
                variant="outlined"
                sx={{ mb: 0.5 }}
              />
            ))}
          </Stack>
        </Box>
      </Box>
    </Paper>
  );
}

function ProcessesOverview() {
  return (
    <Box sx={{ p: { xs: 2, sm: 3, md: 4 }, maxWidth: 1200, mx: 'auto' }}>
      <Typography variant="h4" fontWeight={600} gutterBottom sx={{ mb: 1 }}>
        Processes
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Production workflows and process documentation
      </Typography>

      <Grid container spacing={3}>
        {processes.map((process) => (
          <Grid item xs={12} md={6} key={process.path}>
            <ProcessCard process={process} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default ProcessesOverview;
